module.exports = __webpack_public_path__ + "img/incorrect-extract-icon.8a415893.png";